/** M7 banking capture (per CLIENT): bank accounts and their transactions. */

export type BankAccountType = "CHECKING" | "SAVINGS" | "BUSINESS" | "OTHER";

export interface BankAccount {
  id: string;
  name: string;
  institution: string;
  accountLast4: string;
  accountType: BankAccountType;
}

export interface CreateBankAccountPayload {
  name: string;
  institution?: string;
  account_last4?: string;
  account_type?: BankAccountType;
}

export interface BankTransaction {
  id: string;
  date: string;
  description: string;
  /** Signed decimal string: +credit / -debit. Kept as a string — never parsed
   * into a float for display, to avoid precision loss on money. */
  amount: string;
  category: string;
  reconciled: boolean;
}

export interface CreateBankTransactionPayload {
  date: string;
  description: string;
  amount: string;
  category?: string;
  reconciled?: boolean;
}

export const BANK_ACCOUNT_TYPE_OPTIONS: { value: BankAccountType; label: string }[] = [
  { value: "CHECKING", label: "Checking" },
  { value: "SAVINGS", label: "Savings" },
  { value: "BUSINESS", label: "Business" },
  { value: "OTHER", label: "Other" },
];

export const BANK_ACCOUNT_TYPE_LABEL: Record<BankAccountType, string> = {
  CHECKING: "Checking",
  SAVINGS: "Savings",
  BUSINESS: "Business",
  OTHER: "Other",
};
